import { combineReducers } from "redux";
import { dialogueReducer } from "./dialogue/dialogue.reducer";
import { adminReducer } from "./admin/admin.reducer";
import { settingReducer } from "./setting/setting.reducer";
import { dashboardReducer } from "./dashboard/dashboard.reducer";
import { userReducer } from "./user/user.reducer";
import { sellerReducer } from "./seller/seller.reducer";
import { sellerRequestReducer } from "./sellerRequest/sellerRequest.reducer";
import { serviceProviderRequestReducer } from "./serviceProviderRequest/serviceProviderRequest.reducer";
import { serviceCategoryReducer } from "./serviceCategory/serviceCategory.reducer";
import { productReducer } from "./product/product.reducer";
import { categoryReducer } from "./category/category.reducer";
import { orderReducer } from "./order/order.reducer";
import promoCodeReducer from "./PromoCode/promoCode.reducer";
import { FaQReducer } from "./FAQ/faq.reducer";
import { subCategoryReducer } from "./subCategory/subCategory.reducer";
import { withdrawReducer } from "./withdraw/withdraw.reducer";
import { attributeReducer } from "./attribute/attribute.reducer";
import redeemReducer from "./redeem/redeem.reducer";
import { fakeSellerReducer } from "./fake Seller/fakeSeller.reducer";
import { reelsReducer } from "./reels/reels.reducers";
import { fakeReelsReducer } from "./fakeReels/fakeReels.reducers";
import { fakeProductReducer } from "./fakeProduct/fakeProduct.reducer";
import { bankReducer } from "./bank/bank.reducer";
import { currencyReducer } from "./currency/currency.reducer";
import { reportReasonReducer } from "../store/reportReason/reportReason.reducer";
import { videoReportReducer } from "../store/videoReport/videoReport.reducer";
import { sliderReducer } from "./slider/slider.reducer";
import { giftReducer } from "./gift/gift.reducer";
import { coinPackageReducer } from "./coinPackage/coinPackage.reducer";
import { giftTransactionReducer } from "./giftTransaction/giftTransaction.reducer";
import { cashoutRequestReducer } from "./cashoutRequest/cashoutRequest.reducer";
import { logisticsReducer } from "./logistics/logistics.reducer";
import { chatReducer } from "./chat/chat.reducer";
import { supportChatReducer } from "./supportChat/supportChat.reducer";
import { affiliateReducer } from "./affiliate/affiliate.reducer";
import { affiliateRequestReducer } from "./affiliateRequest/affiliateRequest.reducer";
import affiliateWithdrawReducer from "./affiliateWithdraw/affiliateWithdraw.reducer";
import { transactionReducer } from "./transaction/transaction.reducer";
import { affiliateReelsReducer } from "./affiliateReels/affiliateReels.reducers";
import { showcaseReducer } from "./showcase/showcase.reducer";
import { shippingMethodReducer } from "./shippingMethod/shippingMethod.reducer";
import { sourcingRequestReducer } from "./sourcingRequest/sourcingRequest.reducer";
import { auditLogReducer } from "./auditLog/auditLog.reducer";
import { rewardWalletReducer } from "./rewardWallet/rewardWallet.reducer";


export default combineReducers({
  dialogue: dialogueReducer,
  admin: adminReducer,
  dashboard: dashboardReducer,
  user: userReducer,
  seller: sellerReducer,
  fakeSeller: fakeSellerReducer,
  category: categoryReducer,
  subCategory: subCategoryReducer,
  attribute: attributeReducer,
  order: orderReducer,
  product: productReducer,
  fakeProduct: fakeProductReducer,
  withdraw: withdrawReducer,
  redeem: redeemReducer,
  promoCode: promoCodeReducer,
  setting: settingReducer,
  FaQ: FaQReducer,
  sellerRequest: sellerRequestReducer,
  serviceProviderRequest: serviceProviderRequestReducer,
  serviceCategory: serviceCategoryReducer,
  reels: reelsReducer,
  fakeReels: fakeReelsReducer,
  bank: bankReducer,
  currency: currencyReducer,
  reportReason : reportReasonReducer,
  videoReport : videoReportReducer,
  slider: sliderReducer,
  gift: giftReducer,
  coinPackage: coinPackageReducer,
  giftTransaction: giftTransactionReducer,
  cashoutRequest: cashoutRequestReducer,
  logistics: logisticsReducer,
  chat: chatReducer,
  supportChat: supportChatReducer,
  affiliate: affiliateReducer,
  affiliateRequest: affiliateRequestReducer,
  affiliateWithdraw: affiliateWithdrawReducer,
  transaction: transactionReducer,
  affiliateReels: affiliateReelsReducer,
  showcase: showcaseReducer,
  shippingMethod: shippingMethodReducer,
  sourcingRequest: sourcingRequestReducer,
  rewardWallet: rewardWalletReducer,
  auditLog: auditLogReducer,
});
